// "use client";

// import { useState } from "react";
// import {
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { useTranslation } from "react-i18next";
// import GDPRPolicy from "./GDPRPolicy";

// const GDPRPolicyLink = () => {
//   const [open, setOpen] = useState(false);
//   const { t } = useTranslation();

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   return (
//     <>
//       {/* Το link / κουμπί που θα βλέπει ο χρήστης */}
//       <Button variant="text" onClick={handleOpen}>
//         {t("GDPR POLICY")}
//       </Button>

//       {/* Modal με την πλήρη πολιτική */}
//       <Dialog
//         open={open}
//         onClose={handleClose}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle sx={{ m: 0, p: 2 }}>
//           {t("GDPR Title")}
//           <IconButton
//             aria-label="close"
//             onClick={handleClose}
//             sx={{
//               position: "absolute",
//               right: 8,
//               top: 8,
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers>
//           {/* Χρησιμοποιούμε το ίδιο component, αλλά με isModal για να κρύβεται το Download button κλπ */}
//           <GDPRPolicy isModal />
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default GDPRPolicyLink;


// import React, { useState } from "react";
// import { Box, Link, Modal } from "@mui/material";
// import GDPRPOLICY from "../screens/GdprPolicyScreen";

// export default function GDPRPolicyLink() {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       {/* CLICKABLE LINK */}
//       <Link
//         sx={{ cursor: "pointer", color: "primary.main", textDecoration: "underline" }}
//         onClick={() => setOpen(true)}
//       >
//         GDPR POLICY
//       </Link>

//       {/* MODAL */}
//       <Modal
//         open={open}
//         onClose={() => setOpen(false)}
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: "90%",
//             maxWidth: 900,
//             maxHeight: "90vh",
//             bgcolor: "background.paper",
//             p: 3,
//             overflowY: "auto",
//             borderRadius: 2,
//             boxShadow: 24,
//           }}
//         >
//           <GDPRPOLICY isModal={true} />
//         </Box>
//       </Modal>
//     </>
//   );
// }


// src/components/GDPRPolicyLink.jsx
import React, { useState } from "react";
import { Box, Link, Modal, Button, Stack } from "@mui/material";
import GDPRPOLICY from "../screens/GdprPolicyScreen";

const GDPRPolicyLink = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Το κλικ εδώ ανοίγει το ίδιο modal style */}
      <Link
        component="button"
        type="button"
        onClick={() => setOpen(true)}
        sx={{ cursor: "pointer", textDecoration: "underline" }}
      >
        GDPR Policy
      </Link>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 800,
            maxHeight: "90vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          {/* Χρησιμοποιούμε **ακριβώς** το ίδιο component */}
          <GDPRPOLICY
            isModal={true}
            // εδώ ΔΕΝ κάνουμε accept, απλώς κλείνουμε
            onAgree={() => setOpen(false)}
            isSubmitting={false}
          />

          {/* Προαιρετικό extra κουμπί κλεισίματος */}
          <Stack direction="row" justifyContent="flex-end" mt={2}>
            <Button variant="outlined" onClick={() => setOpen(false)}>
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default GDPRPolicyLink;
